import type { ActionTree, ActionContext } from 'vuex'
import type { RootState } from '@/store'
import type { DeviceIntervalsState, StartIntervalPayload } from './types'
import { DEVICE_INTERVALS_ACTIONS, DEVICE_INTERVALS_MUTATIONS, IntervalType } from './types'

interface IDeviceIntervalsActions extends ActionTree<DeviceIntervalsState, RootState> {
  [DEVICE_INTERVALS_ACTIONS.START_APP_INTERVAL](
    context: ActionContext<DeviceIntervalsState, RootState>,
    payload: StartIntervalPayload
  ): void
  [DEVICE_INTERVALS_ACTIONS.START_MANAGE_DEVICES_INTERVAL](
    context: ActionContext<DeviceIntervalsState, RootState>,
    payload: StartIntervalPayload
  ): void
  [DEVICE_INTERVALS_ACTIONS.CLEAR_INTERVAL](
    context: ActionContext<DeviceIntervalsState, RootState>
  ): void
  [DEVICE_INTERVALS_ACTIONS.RESTART_APP_INTERVAL](
    context: ActionContext<DeviceIntervalsState, RootState>
  ): void
}

const actions: IDeviceIntervalsActions = {
  [DEVICE_INTERVALS_ACTIONS.START_APP_INTERVAL](
    { commit, dispatch, state },
    { callback, interval }
  ) {
    if (state.activeIntervalType === IntervalType.APP) {
      return
    }

    commit(DEVICE_INTERVALS_MUTATIONS.SET_APP_UPDATE_CALLBACK, callback)
    commit(DEVICE_INTERVALS_MUTATIONS.SET_APP_INTERVAL, interval)

    dispatch(DEVICE_INTERVALS_ACTIONS.CLEAR_INTERVAL)

    if (callback) {
      callback()
    }

    const intervalId = setInterval(callback, interval)
    commit(DEVICE_INTERVALS_MUTATIONS.SET_INTERVAL, { id: intervalId, type: IntervalType.APP })
  },

  [DEVICE_INTERVALS_ACTIONS.START_MANAGE_DEVICES_INTERVAL](
    { commit, dispatch, state },
    { callback, interval }
  ) {
    if (state.activeIntervalType === IntervalType.MANAGE_DEVICES) {
      return
    }

    dispatch(DEVICE_INTERVALS_ACTIONS.CLEAR_INTERVAL)

    if (callback) {
      callback()
    }

    const intervalId = setInterval(callback, interval)
    commit(DEVICE_INTERVALS_MUTATIONS.SET_INTERVAL, {
      id: intervalId,
      type: IntervalType.MANAGE_DEVICES
    })
  },

  [DEVICE_INTERVALS_ACTIONS.CLEAR_INTERVAL]({ commit, state }) {
    if (state.activeIntervalId) {
      clearInterval(state.activeIntervalId)
      commit(DEVICE_INTERVALS_MUTATIONS.CLEAR_INTERVAL)
    }
  },

  [DEVICE_INTERVALS_ACTIONS.RESTART_APP_INTERVAL]({ dispatch, state }) {
    if (state.appUpdateCallback && state.appInterval) {
      dispatch(DEVICE_INTERVALS_ACTIONS.START_APP_INTERVAL, {
        callback: state.appUpdateCallback,
        interval: state.appInterval
      })
    }
  }
}

export default actions
